export enum PaymentMethodType {
	NotSet = -1,
    ECheck = 0,
    Card = 1
}
